import { apiSlice } from "./apiSlice";
import { QUIZ_URL } from "../constants";

export const quizApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ======================================================
    // Quiz Management
    // ======================================================

    createQuiz: builder.mutation({
      query: (data) => ({
        url: QUIZ_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Quiz"],
    }),

    getQuizzes: builder.query({
      query: () => ({
        url: QUIZ_URL,
      }),
      providesTags: ["Quiz"],
      keepUnusedDataFor: 5,
    }),

    getQuizById: builder.query({
      query: (quizId) => ({
        url: `${QUIZ_URL}/${quizId}`,
      }),
      providesTags: (result, error, quizId) => [
        { type: "Quiz", id: quizId },
      ],
      keepUnusedDataFor: 5,
    }),

    updateQuiz: builder.mutation({
      query: ({ quizId, ...data }) => ({
        url: `${QUIZ_URL}/${quizId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Quiz"],
    }),

    deleteQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${QUIZ_URL}/${quizId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Quiz"],
    }),

    // ======================================================
    // Blueprint
    // ======================================================

    saveQuizBlueprint: builder.mutation({
      query: ({ quizId, blueprint }) => ({
        url: `${QUIZ_URL}/${quizId}/blueprint`,
        method: "PUT",
        body: {
          blueprint,
        },
      }),
      invalidatesTags: ["Quiz", "QuizBlueprint"],
    }),

    getQuizBlueprint: builder.query({
      query: (quizId) => ({
        url: `${QUIZ_URL}/${quizId}/blueprint`,
      }),
      providesTags: ["QuizBlueprint"],
      keepUnusedDataFor: 5,
    }),

    validateQuizBlueprint: builder.mutation({
      query: ({ quizId, blueprint }) => ({
        url: `${QUIZ_URL}/${quizId}/validate-blueprint`,
        method: "POST",
        body: {
          blueprint,
        },
      }),
    }),

    getBlueprintStatistics: builder.query({
      query: (quizId) => ({
        url: `${QUIZ_URL}/${quizId}/blueprint/statistics`,
      }),
      providesTags: ["QuizBlueprint"],
      keepUnusedDataFor: 5,
    }),

    updateQuizActiveStatus: builder.mutation({
  query: ({ quizId, isActive }) => ({
    url: `${QUIZ_URL}/${quizId}/active`,
    method: "PATCH",
    body: {
      isActive,
    },
  }),

  invalidatesTags: ["Quiz"],
}),

    // ======================================================
    // Question Generation
    // ======================================================

    generateQuizQuestions: builder.mutation({
      query: (quizId) => ({
        url: `${QUIZ_URL}/${quizId}/generate`,
        method: "POST",
      }),
      invalidatesTags: ["Quiz"],
    }),

    regenerateQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${QUIZ_URL}/${quizId}/regenerate`,
        method: "POST",
      }),
      invalidatesTags: ["Quiz"],
    }),

    // ======================================================
    // Question Availability
    // ======================================================

    getQuestionAvailability: builder.query({
  query: ({ subject, chapter, difficulty }) => ({
    url: `${QUIZ_URL}/question-availability`,
    params: {
      subject,
      chapter,
      difficulty,
    },
  }),
  keepUnusedDataFor: 5,
}),
getQuizStartAvailability: builder.query({
  query: (quizId) => ({
    url: `${QUIZ_URL}/${quizId}/start-availability`,
  }),
  keepUnusedDataFor: 5,
}),
  }),
});

export const {
  // Quiz
  useCreateQuizMutation,
  useGetQuizzesQuery,
  useGetQuizByIdQuery,
  useUpdateQuizMutation,
  useDeleteQuizMutation,

  // Blueprint
  useSaveQuizBlueprintMutation,
  useGetQuizBlueprintQuery,
  useValidateQuizBlueprintMutation,
  useGetBlueprintStatisticsQuery,

  // Generation
  useGenerateQuizQuestionsMutation,
  useRegenerateQuizMutation,

  // Availability
  useGetQuestionAvailabilityQuery,
  useGetQuizStartAvailabilityQuery,
  useUpdateQuizActiveStatusMutation,
} = quizApiSlice;